/* export default interface SlotType {
    Index: number | string,
    AssociatedDriverId: number | string,
    Diverter: number | string,
    Parent: {
        Index: number | string
    }
} */

export class Slot {
    index: number;
    associatedDriverId: number | undefined = undefined;
    diverter: number | undefined = undefined;
    parent: Slot | undefined = undefined;

    constructor(index: number) {
        this.index = index;
    }
}